// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App"; // Your main App component with Routes definition
import { AuthProvider } from "./pages/Home1"; // Import the CORRECT AuthProvider

import "./index.css"; // Your global custom styles
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS globally (ensure it's installed)

// Get the root DOM element
const rootElement = document.getElementById("root");

// Create a React root attached to the DOM element
const root = ReactDOM.createRoot(rootElement);

// Render the application
root.render(
  <React.StrictMode>
    {" "}
    {/* Helps identify potential problems in components */}
    <BrowserRouter>
      {" "}
      {/* Provides routing context to the entire app */}
      <AuthProvider>
        {" "}
        {/* Provides authentication context to the entire app */}
        <App /> {/* Your main application component containing Routes */}
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
